// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Verse Database Configuration
// ═══════════════════════════════════════════════════════════════════════════
// Configure which verses to block, weight, and categorize.
// The actual verse data is loaded separately from verses-data.js
// ═══════════════════════════════════════════════════════════════════════════

export const VERSE_CONFIG = {
    // ─────────────────────────────────────────────────────────────────────────
    // BLOCKLIST
    // Verses to NEVER show. Add any reference to this array.
    // Format: "Book Chapter:Verse" or "Book Chapter:Start-End"
    // ─────────────────────────────────────────────────────────────────────────
    blocklist: [
        // Potentially harmful when taken out of context
        "Matthew 27:5",        // "went and hanged himself"
        "Luke 10:37",          // "Go and do likewise" (when following above)

        // Graphic violence without redemptive context
        "Judges 19:29",        // Dismemberment
        "2 Kings 2:24",        // Bears mauling children

        // Genealogies and lists (not devotionally impactful)
        // Add specific verses from Numbers, Chronicles genealogies as needed

        // Add any verse reference here to prevent it from appearing
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // BOOK WEIGHTS
    // Higher weight = more likely to appear
    // Default weight is 1.0
    // ─────────────────────────────────────────────────────────────────────────
    bookWeights: {
        // Devotionally rich books (higher weight)
        "Psalms": 3.0,
        "Proverbs": 2.5,
        "John": 2.5,
        "Romans": 2.0,
        "Isaiah": 2.0,
        "Matthew": 2.0,
        "Ephesians": 2.0,
        "Philippians": 2.0,
        "James": 1.8,
        "1 John": 1.8,
        "Hebrews": 1.5,
        "Colossians": 1.5,
        "1 Peter": 1.5,
        "Galatians": 1.5,

        // Narrative books (slightly lower for individual verses)
        "Genesis": 1.2,
        "Exodus": 1.0,
        "Luke": 1.5,
        "Mark": 1.3,
        "Acts": 1.0,

        // Law and detailed regulations (lower weight)
        "Leviticus": 0.3,
        "Numbers": 0.3,
        "Deuteronomy": 0.8,

        // Other (default 1.0 if not listed)
    },

    // ─────────────────────────────────────────────────────────────────────────
    // DIVINE VERSE POOL
    // These verses are marked as "linger-worthy" for Divine Verse feature
    // When Divine Verse triggers, it picks from this pool
    // ─────────────────────────────────────────────────────────────────────────
    divineVersePool: [
        "Psalm 46:10",
        "Psalm 23:1",
        "Psalm 27:4",
        "Isaiah 41:10",
        "Isaiah 43:1",
        "Jeremiah 29:11",
        "Matthew 11:28",
        "John 14:27",
        "John 15:5",
        "Romans 8:28",
        "Romans 8:38-39",
        "2 Corinthians 12:9",
        "Philippians 4:6-7",
        "1 Peter 5:7",
        "Revelation 21:4",
    ],

    // ─────────────────────────────────────────────────────────────────────────
    // CATEGORIES
    // For future filtering/mood features
    // ─────────────────────────────────────────────────────────────────────────
    categories: {
        comfort: [
            "Psalm 23:1-6",
            "Psalm 46:1",
            "Isaiah 41:10",
            "Matthew 11:28",
            "John 14:27",
            "Romans 8:28",
            "2 Corinthians 1:3-4",
        ],
        courage: [
            "Joshua 1:9",
            "Deuteronomy 31:6",
            "Isaiah 41:10",
            "Psalm 27:1",
            "Romans 8:31",
        ],
        wisdom: [
            "Proverbs 3:5-6",
            "James 1:5",
            "Proverbs 2:6",
            "Colossians 2:3",
        ],
        peace: [
            "John 14:27",
            "Philippians 4:6-7",
            "Isaiah 26:3",
            "Psalm 29:11",
        ],
        love: [
            "1 Corinthians 13:4-7",
            "Romans 8:38-39",
            "1 John 4:8",
            "John 3:16",
        ],
        hope: [
            "Romans 15:13",
            "Jeremiah 29:11",
            "Romans 5:5",
            "Hebrews 6:19",
        ],
    },
};

export default VERSE_CONFIG;
